import toRenderableItemSubstrate from './to-renderable-item-substrate'

export default toRenderableItemSubstrate
